import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import useOpenSnackbar from "custom-hooks/snacbar/useOpenSnackbar";
import { useNavigate } from "react-router";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
const { format, parse } = require("date-fns");

declare var ZestPayPop: any;


export function useMortgageApplication() {
  const { openSnackbar, severity, message, openToast, setOpenToast, duration } =
    useOpenSnackbar();
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const queryClient = useQueryClient();
  const [appFeedback, setAppFeedback] = useState(false);

  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/application`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (response) => {
        if (response.data.submitted) {
          setAppFeedback({
            open: true,
            status: "success",
            message:
              "You have successfully submitted your application, please proceed to Documents to upload necessary documents",
          });
        } else {
          //setOpenModal(false);
          setAppFeedback({
            open: true,
            status: "success",
            message:
              "Your entries have been saved, till you are ready to continue",
          });
          //openSnackbar("success", "Successful");
        }

        queryClient.invalidateQueries(["applications"]);
      },
      onError: (error) => {
        //openSnackbar("error", error?.response?.data?.message);
        setAppFeedback({
          open: true,
          status: "error",
          message: error?.response?.data?.message,
        });
      },
    }
  );

  return {
    appFeedback,
    setAppFeedback,
    openSnackbar,
    severity,
    message,
    openToast,
    setOpenToast,
    duration,
    openModal,
    setOpenModal,
    loading: isLoading,
    submit: mutate,
  };
}

export function useGetCreditCheck() {
  const [screen, setScreen] = useState("credit-check");
  const [feedbackState, setFeedbackState] = useState("");
  const { mutate, isLoading } = useMutation(
    (data) => {
      return axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/application/credit-check`,
          data
        )
        .then((res) => {
          return res.data;
        });
    },
    {
      onSuccess: (response) => {
        if (response.status) {
          setFeedbackState({
            open: true,
            status: "success",
            message: "Credit checked successfull",
          });
          //setFeedbackState("success");
          setScreen("credit-check-success");
        } else {
          setFeedbackState({
            open: true,
            status: "error",
            message: response.message,
          });
          setScreen("credit-check-failed");
        }
      },
      onError: (error) => {
        setFeedbackState({
          open: true,
          status: "error",
          message: error?.response?.data?.message,
        });
        setScreen("credit-check-failed");
      },
    }
  );

  const checkCredit = (data) => {
    const formattedDate = moment(data.dob).format("YYYY/MM/DD"); 

    mutate({
      dob: formattedDate,
      bvn: data.bvn,
    });
  };
  return {
    screen,
    setScreen,
    feedbackState,
    checkCredit: checkCredit,
    loadingCreditCheck: isLoading,
  };
}

// export function useSaveAndQuit() {
//   const { openSnackbar, severity, message, openToast, setOpenToast, duration } =
//     useOpenSnackbar();
//   const [openModal, setOpenModal] = useState(false);
//   const queryClient = useQueryClient();
//   const { mutate, isLoading } = useMutation(
//     (data) =>
//       axios
//         .post(`${process.env.REACT_APP_BASE_URL}/application`, data)
//         .then((res) => {
//           return res.data;
//         }),
//     {
//       onSuccess: (response) => {
//         queryClient.invalidateQueries(["applications"]);
//       },
//       onError: (error) => {
//         openSnackbar("error", error?.response?.data?.message);
//       },
//     }
//   );

//   return {
//     openSnackbar,
//     severity,
//     message,
//     openToast,
//     setOpenToast,
//     duration,
//     openModal,
//     setOpenModal,
//     loading: isLoading,
//     saveAndQuit: mutate,
//   };
// }

export function useApplicationPayment() {
  const { openSnackbar, severity, message, openToast, setOpenToast, duration } =
    useOpenSnackbar();
  const [openModal, setOpenModal] = useState(false);
  const queryClient = useQueryClient();
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [application, setApplication] = useState({});
  const [paymentFeedback, setPaymentFeedback] = useState({});
  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/verify`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries(["applications"]);
        setPaymentFeedback({
          open: true,
          status: "success",
          message:
            "You have successfully submitted your application, please check back for feedback",
        });
      },
      onError: (error) => {
        setPaymentFeedback({
          open: true,
          status: "error",
          message: error?.response?.data?.message,
        });
      },
    }
  );
  const handlePayment = (_application) => {
    setApplication(_application);

    setLoadingPayment(true);
    //sample payment request amount: _application.payments.total * 100,
    var samplePaymentRequest = {
      site_redirect_url: process.env.REACT_APP_INTERSWITCH_REDIRECT_URL,
      merchant_code: process.env.REACT_APP_INTERSWITCH_MERCHANT_CODE,
      pay_item_id: process.env.REACT_APP_INTERSWITCH_PAY_ITEM,
      txn_ref: uuidv4(),
      amount: _application.payments.total * 100,
      currency: 566, // ISO 4217 numeric code of the currency used
      onComplete: paymentCallback,
      mode: "LIVE",
    };
    //call webpayCheckout to initiate the payment

    window.webpayCheckout(samplePaymentRequest);
  };
  //declare callback function
  function paymentCallback(response) {
    if (response.payRef) {
      // console.log("payref is " + response.payRef)
      setLoadingPayment(false);
      setOpenModal(false);
      //openSnackbar("success", "Successful");

      mutate({
        reference: response.txnref,
        applicationId: application.id,
        amount: response.amount,
        paymentType:"interswitch"
      });
    } else {
      setOpenModal(false);
      setPaymentFeedback({
        open: true,
        status: "error",
        message: "Payment not successful, please try again later",
      });
      //openSnackbar("error", "Payment not successful, Please try again");
    }
  }


  const handlePaymentZest = (_application) => {

    setApplication(_application);
    setLoadingPayment(true);
    
		let handler = ZestPayPop.setup({
			key: process.env.REACT_APP_ZEST_KEY,
			amount: _application.payments.total * 100,
			email:_application.email,
			currency: "NGN",
			ref: `ZESTHOMELOAN-${Math.ceil(Math.random() * 10e10)}`,
			onClose: function () {
				console.log("Window closed.");
			},
			callback: paymentCallbackZest
		});
		handler.openIframe();




    
  }


  function paymentCallbackZest(response) {
    console.log(response)

    if (response.status == "success") {
      setLoadingPayment(false);
      setOpenModal(false);

      mutate({
        reference: response.reference,
        applicationId: application.id,
        amount: application.payments.total,
        paymentType:"zest"
      });
    } else {
      setOpenModal(false);
      setPaymentFeedback({
        open: true,
        status: "error",
        message: "Payment not successful, please try again later",
      });
      //openSnackbar("error", "Payment not successful, Please try again");
    }


  }

  return {
    paymentFeedback,
    setPaymentFeedback,
    setApplication,
    handlePayment,
    handlePaymentZest,
    openSnackbar,
    severity2: severity,
    message2: message,
    openToast2: openToast,
    setOpenToast2: setOpenToast,
    duration: duration,
    openModal,
    setOpenModal,
    loading: loadingPayment,
  };
}